import styled from 'styled-components';

import { columnFlex } from 'core/styles';

export const Container = styled.div`
  display: flex;
`;

export const Content = styled.main`
  ${columnFlex};
  padding: 0;
  background-color: ${({ theme }) => theme.palette.grey[100]};
  min-height: 100vh;
  min-width: 0;
`;
